// extracted by mini-css-extract-plugin
export var body = "_m3-0";
export var sectionHeader = "_m3-4";
export var shortcutColumns = "_m3-2";
export var shortcutList = "_m3-1";
export var shortcutSection = "_m3-3";